import Ajax from 'js/utils/ajax/ajax';

export const cancelOrder = (orderId: number | undefined) => Ajax.delete(`/orders/v1/${orderId}`);
